module.exports = __webpack_public_path__ + "img/tk.bfa42fee.png";